"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeEvent = exports.emitEvent = void 0;
var defaultEventOptions = { bubbles: true, cancelable: true };
function emitEvent(name, options) {
    if (options === void 0) { options = defaultEventOptions; }
    var event = new Event(name, options);
    document.dispatchEvent(event);
}
exports.emitEvent = emitEvent;
function subscribeEvent(name, callback) {
    window.addEventListener(name, callback);
}
exports.subscribeEvent = subscribeEvent;
//# sourceMappingURL=index.js.map